import { z } from 'zod'

export const auditActionSchema = z.enum([
  'leave.created',
  'leave.updated',
  'leave.cancelled',
  'leave.approved',
  'leave.rejected',
  'leave.escalated',
  'leave.slack_approved',
  'leave.slack_rejected',
  'employee.created',
  'employee.updated',
  'employee.deactivated',
  'blackout.created',
  'blackout.deleted',
  // NEW (Slice 16a): AI-suggestion row written when AI suggests weights.
  'priority_rules.suggested',
  'priority_rules.updated',
  // NEW (Slice 16d): Director-tier quarterly CSV export of priority-rules audit rows.
  'audit.exported_priority_rules_quarterly',
  'auth.login',
  'auth.logout',
])

export type AuditAction = z.infer<typeof auditActionSchema>

// ── AI provenance block ───────────────────────────────────────────────────────
// Populated on audit rows where the action was AI-assisted (Slice 16a+).
// All fields are nullable — pre-Slice-16a rows return null for every field.

export const auditAiProvenanceSchema = z.object({
  aiInvocationId: z.guid().nullable(),
  aiModelId: z.string().nullable(),
  aiPromptVersion: z.string().nullable(),
  aiInputHash: z.string().nullable(),
  aiConfidence: z.number().nullable().optional(),
  aiOverrideFlag: z.boolean().nullable().optional(),
  aiOverrideReason: z.string().nullable().optional(),
})

export type AuditAiProvenance = z.infer<typeof auditAiProvenanceSchema>

export const auditLogEntrySchema = z.object({
  id: z.guid(),
  actorEmployeeId: z.guid().nullable(),
  actorRole: z.string().nullable(),
  action: auditActionSchema,
  subjectType: z.string(),
  subjectId: z.guid().nullable(),
  before: z.record(z.string(), z.unknown()).nullable(),
  after: z.record(z.string(), z.unknown()).nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
  source: z.enum(['web', 'api', 'slack', 'system']).default('web'),
  createdAt: z.string().datetime(),
  // Optional — present only when the backend includes AI provenance columns.
  aiProvenance: auditAiProvenanceSchema.nullable().optional(),
})

export type AuditLogEntry = z.infer<typeof auditLogEntrySchema>
